import type { NavigateFunction } from 'react-router-dom';
import toast from 'react-hot-toast';
import { clearClientSessionState, markExplicitLogout } from './sessionCleanup';
import { logout, logoutAllSessions } from '../features/auth/api/auth.api';

async function runLogoutCleanup(
  action: () => Promise<void>,
  successMessage: string,
  navigate: NavigateFunction
): Promise<void> {
  try {
    await action();
    toast.success(successMessage);
  } catch {
    // Local cleanup must still complete if the server session is already gone.
  } finally {
    markExplicitLogout();
    clearClientSessionState();
    navigate('/login', { replace: true });
  }
}

export async function logoutAndCleanup(navigate: NavigateFunction): Promise<void> {
  await runLogoutCleanup(logout, 'Signed out successfully', navigate);
}

export async function logoutAllAndCleanup(navigate: NavigateFunction): Promise<void> {
  await runLogoutCleanup(logoutAllSessions, 'Signed out from all sessions', navigate);
}
